import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
import scrollama from 'scrollama';
export default {
  name: 'MdmParallax',
  props: {
    offset: {
      type: Number,
      required: true
    },
    step: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      scroller: null,
      status: {}
    };
  },
  computed: {
    stickyStyle: function stickyStyle() {
      return "transform: translate3d(-".concat(this.status.progress * 100, "%, 0px, 0px)");
    }
  },
  created: function created() {
    this.scroller = scrollama();
  },
  mounted: function mounted() {
    var _this = this;

    this.scroller.setup({
      offset: this.offset,
      step: this.step,
      graphic: '.graphic',
      progress: true,
      debug: false
    }).onStepProgress(this.handleStepProgress); // setup resize event

    this.$nextTick(function () {
      _this.resize();
    });
    window.addEventListener('resize', this.resize, {
      passive: true
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize: function resize() {
      this.scroller.resize();
    },
    handleStepProgress: function handleStepProgress(response) {
      this.status = response;
    }
  }
};